<template>
  <fade-in class="introduction-group">
    <p>&#12296;{{ title }}&#12297;</p>
    <div class="container container-work">
      <div class="work-contents-wrapper">
        <slot></slot>
      </div>
    </div>
  </fade-in>
</template>

<script>
import FadeIn from '@/components/FadeIn.vue';

export default {
  components: { FadeIn },
    props: [ 'title' ]
}
</script>

<style lang="scss">
.introduction-group {
  margin-bottom: 105px;
}

</style>
